export default class ChangePassword {
    constructor(token, password) {
        this.token = token;
        this.password = password;
    }
}


// WEBPACK FOOTER //
// ./src/model/ChangePassword.js